import Vue from 'vue'
import { deleteAction, getAction, postAction, downFile } from '@/api/manage'
import { ajaxGetDictItems } from '@/api/api'
//import SparkMD5 from 'spark-md5'

export default {
  data() {
    return {
      // 父组件实例
      _p: {},

      // 表单验证预设rule
      _r: {},

      ////#region 定义弹出框布局
      //// 宽度 明确指定了宽度则size不生效
      //// width: null,
      //// 弹出框大小 可选 smaller small normal big full
      //size: 'smaller',
      //// 项目列数
      column: 1,
      //// 弹出框的class
      //// dialogClass: ''
      ////#endregion 定义弹出框布局

      primaryColorKey: this.$primaryColorKey
    }
  },
  beforeCreate() {
    // 父组件实例
    this._p = this.$attrs._p

    // 表单验证预设rule
    this._r = {
      required: { required: true, message: '请填写必须项目', trigger: 'change' }
    }
  },
  created() {},
  mounted() {},
  methods: {
    /*******************************************
     * 根据rules判断项目是否必填
     *******************************************/
    $isRequired(item) {
      // 没有规则则肯定非必填
      if (!this.rules) {
        return ''
      }

      // 该项目没有规则
      if (!this.rules[item]) {
        return ''
      }

      for (let index = 0; index < this.rules[item].length; index++) {
        var rule = this.rules[item][index]
        if (rule.required) {
          return 'required'
        }
      }

      return ''
    },

    /*******************************************
     * 打开工作流页面
     * 注意：虚拟流程的时候（procInstId以UR开头），需传入component
     *******************************************/
    $openWF(procInstId, component) {
      if (!procInstId) {
        return
      }

      this.$refs.ApplyModal.procInstId = procInstId
      this.$refs.ApplyModal.forceEdit = false
      this.$refs.ApplyModal.finalEdit = false

      // 虚拟流程
      if (XEUtils.startsWith(procInstId, 'UR')) {
        // 虚拟项目却没有设置component,则直接return
        if (!component) {
          if (XEUtils.startsWith(procInstId, 'URTB') || XEUtils.startsWith(procInstId, 'URLY')) {
            component = 'k04/k0407/PaymentOrderApply'
          } else if (XEUtils.startsWith(procInstId, 'URJK') || XEUtils.startsWith(procInstId, 'URYJ')) {
            component = 'k04/k0407/LoanBillApply'
          } else {
            return
          }
        }

        this.$refs.ApplyModal.component = component
        this.$refs.ApplyModal.applicantInfo.starterRelation = {}
        this.$refs.ApplyModal.isUnReal = true
      }

      this.$refs.ApplyModal.handleOpen()
    },
    $editWF(procInstId, component) {
      this.$refs.ApplyModal.procInstId = procInstId
      this.$refs.ApplyModal.forceEdit = true

      // 虚拟流程
      if (XEUtils.startsWith(procInstId, 'UR')) {
        // 虚拟项目却没有设置component,则直接return
        if (!component) {
          if (XEUtils.startsWith(procInstId, 'URTB') || XEUtils.startsWith(procInstId, 'URLY')) {
            component = 'k04/k0407/PaymentOrderApply'
          } else if (XEUtils.startsWith(procInstId, 'URJK') || XEUtils.startsWith(procInstId, 'URYJ')) {
            component = 'k04/k0407/LoanBillApply'
          } else {
            return
          }
        }

        this.$refs.ApplyModal.component = component
        this.$refs.ApplyModal.applicantInfo.starterRelation = {}
        this.$refs.ApplyModal.isUnReal = true
      }

      this.$refs.ApplyModal.handleOpen()
    },
    $approveWF(procInstId) {
      this.$refs.ApplyModal.procInstId = procInstId
      this.$refs.ApplyModal.isHrPage = true
      this.$refs.ApplyModal.handleOpen()
    },
    $createWF(flowName, flowInitData) {
      if (!this.$getLoginUser().mainRelation) {
        this.$notification.error({
          message: this.$t('disp.error'),
          description: '该用户没有所属信息，不能新建流程。'
        })

        return
      }

      // 根据flowName获取流程信息
      getAction('/flow/getFlowMetaInfo', { flowName: flowName }).then(res => {
        if (res.success) {
          if (res.result.length == 0) {
            this.$notification.error({
              message: this.$t('disp.error'),
              description: '获取流程配置信息失败，请联系管理员。'
            })

            return
          }

          var flow = {}
          // 只有一条
          if (res.result.length == 1) {
            flow = res.result[0]
          }
          // 找到多条,需判断权限
          else if (res.result.length > 1) {
            var auth = JSON.parse(sessionStorage['LOGIN_USER_BUTTON_AUTH'])
            for (let index = 0; index < res.result.length; index++) {
              if (XEUtils.filter(auth, r => r.action == res.result[index].perms).length > 0) {
                flow = res.result[index]
                break
              }
            }
          }

          if (XEUtils.isEmpty(flow)) {
            this.$notification.error({
              message: this.$t('disp.error'),
              description: '该用户没有新建此流程的权限。'
            })

            return
          }

          if (flow.startDate && moment().format('YYYY-MM-DD') < moment(flow.startDate).format('YYYY-MM-DD')) {
            this.$notification.error({
              message: this.$t('disp.error'),
              description: '流程暂不可用，请联系管理员。'
            })

            return
          }

          if (flow.endDate && moment().format('YYYY-MM-DD') > moment(flow.endDate).format('YYYY-MM-DD')) {
            this.$notification.error({
              message: this.$t('disp.error'),
              description: '流程暂不可用，请联系管理员。'
            })

            return
          }

          this.$refs.ApplyModal.popupFrom = '1'
          this.$refs.ApplyModal.modelId = flow.modelId
          this.$refs.ApplyModal.deploymentId = flow.deploymentId
          this.$refs.ApplyModal.title = flow.name
          this.$refs.ApplyModal.component = flow.component
          this.$refs.ApplyModal.status = 'disp.flow.apply'
          this.$refs.ApplyModal.applicantInfo.starterRelation = this.$getLoginUser().mainRelation
          this.$refs.ApplyModal.flowInitData = flowInitData
          this.$refs.ApplyModal.handleOpen()
        }
      })
    },

    /*******************************************
     * 获取当前login用户信息
     *******************************************/
    $getLoginUser() {
      if (!localStorage['pro__Login_Userinfo']) {
        return undefined
      } else {
        return JSON.parse(localStorage['pro__Login_Userinfo']).value
      }
    },

    $hasAuth(action) {
      if (this.$getLoginUser().editableFlag == '1') {
        return true
      }

      if (XEUtils.filter(JSON.parse(sessionStorage['LOGIN_USER_BUTTON_AUTH']), r => r.action == action).length > 0) {
        return true
      }

      return false
    },



    /*******************************************
     * 获取字典列表或值
     *
     * 被调用的地方很多,写成promise的话非常不方便
     * 因此在login.vue和main.js一次取好并保存在sessionStorage中
     *******************************************/
    $getDict(code, value, forceRefresh) {
      if (forceRefresh || !sessionStorage['dictCode_' + code]) {
        ajaxGetDictItems('-1', null).then(res => {
          if (res.success) {
            // sessionStorageをリフレッシュする
            var sessionKeys = Object.keys(sessionStorage)
            for (var i = 0; i < sessionKeys.length; i++) {
              //可以对key 进行分析从而决定是否要删除sessionStorage 里的缓存
              if (sessionKeys[i].indexOf('dictCode_') >= 0) {
                sessionStorage.removeItem(sessionKeys[i])
              }
            }

            var dictGroup = XEUtils.groupBy(res.result, 'code')
            Object.keys(dictGroup).forEach(dictCode => {
              sessionStorage['dictCode_' + dictCode] = JSON.stringify(dictGroup[dictCode])
            })
          }
        })
      } else {
        if (value || value == 0 || value == '0') {
          var dict = XEUtils.first(
            XEUtils.filter(JSON.parse(sessionStorage['dictCode_' + code]), item => item.value == value)
          )
          if (dict) {
            return dict.text
          }
        } else {
          var dicts = XEUtils.orderBy(JSON.parse(sessionStorage['dictCode_' + code]), [['sortOrder', 'asc']])
          return dicts
        }
      }
    },

    /*******************************************
     * 获取组织树
     *
     * 被调用的地方很多,写成promise的话非常不方便
     * 因此在login.vue和main.js一次取好并保存在sessionStorage中
     *******************************************/
    $getDepartTree(departId, forceRefresh) {
      if (forceRefresh || !sessionStorage['SYS_DEPART_TREE']) {
        getAction('/blaze-sys/k00/k0002/DepartManage/getDepartCompanyTree', { departFlg: 1, searchFlg: 0 }).then(res => {
          if (res.success) {
            sessionStorage['SYS_DEPART_TREE'] = JSON.stringify(res.result)
          }
        })
      } else {
        var departTree = JSON.parse(sessionStorage['SYS_DEPART_TREE'])
        if (departId) {
          var found = XEUtils.findTree(departTree, item => item.id == departId)
          if (found) {
            return found.item
          } else {
            return null
          }
        } else {
          return departTree
        }
      }
    },

    /*******************************************
     * 获取客户公司树（不含部门）
     *
     * 注意调用本方法需要添加 await
     *******************************************/
    $getCompanyTree(companyId) {
      return new Promise((resolve, reject) => {
        if (sessionStorage['SYS_COMPANY_TREE']) {
          var result = JSON.parse(sessionStorage['SYS_COMPANY_TREE'])

          if (companyId) {
            var found = XEUtils.findTree(result, item => item.id == companyId)
            if (found) {
              resolve(found.item)
            } else {
              resolve(null)
            }
          } else {
            resolve(result)
          }
        } else {
          getAction('/blaze-sys/k00/k0002/DepartManage/getDepartCompanyTree', { departFlg: 2, searchFlg: 1 }).then(res => {
            if (res.success) {
              var result = res.result
              sessionStorage['SYS_COMPANY_TREE'] = JSON.stringify(result)

              if (companyId) {
                var found = XEUtils.findTree(result, item => item.id == companyId)
                if (found) {
                  resolve(found.item)
                } else {
                  resolve(null)
                }
              } else {
                resolve(result)
              }
            } else {
              resolve(null)
            }
          })
        }
      })
    },

    /*******************************************
     * 获取职位信息
     *
     * 被调用的地方很多,写成promise的话非常不方便
     * 因此在login.vue和main.js一次取好并保存在sessionStorage中
     *******************************************/
    $getPosition(positionId, forceRefresh) {
      if (forceRefresh || !sessionStorage['SYS_POSITION']) {
        this.$query('sys_position').then(res => {
          if (res.length > 0) {
            sessionStorage['SYS_POSITION'] = JSON.stringify(res)
          }
        })
      } else {
        var sysPositions = JSON.parse(sessionStorage['SYS_POSITION'])
        if (positionId) {
          var found = XEUtils.filter(sysPositions, item => item.id == positionId)
          if (found.length > 0) {
            return found[0]
          } else {
            return null
          }
        } else {
          let results = XEUtils.orderBy(
            XEUtils.filter(sysPositions, item => item.delFlag == 0),
            [['postRank', 'desc']]
          )

          results.forEach(r => {
            r.value = r.id
            r.text = r.name
          })

          return results
        }
      }
    },

    /*******************************************
     * 获取条线信息
     *
     * 被调用的地方很多,写成promise的话非常不方便
     * 因此在login.vue和main.js一次取好并保存在sessionStorage中
     *******************************************/
    $getBizLine(bizLineId, forceRefresh) {
      if (forceRefresh || !sessionStorage['SYS_BIZ_LINE']) {
        getAction('/blaze-sys/BizLineManage/list', null).then(res => {
          if (res.success) {
            sessionStorage['SYS_BIZ_LINE'] = JSON.stringify(res.result)
          }
        })
      } else {
        var sysBizLines = JSON.parse(sessionStorage['SYS_BIZ_LINE'])
        if (bizLineId) {
          var found = XEUtils.filter(sysBizLines, item => item.id == bizLineId)
          if (found.length > 0) {
            return found[0]
          } else {
            return null
          }
        } else {
          sysBizLines.forEach(r => {
            r.value = r.id
            r.text = r.bizLineName
          })

          return sysBizLines
        }
      }
    },

    /*******************************************
     * 根据table名及where条件进行单表查询
     * table 数据库表名 例如:sys_depart_company
     * condition 查询条件
     *    1) 可以为where语句,例如:WHERE ITEM_TYPE = 'STAFF_QUANTITY'
     *    2) 如果未出现where关键句,则以ID查询
     * select 检索的列,以逗号隔开
     *
     * 注意调用本方法需要添加 await
     *******************************************/
    $query(table, condition, select) {
      return new Promise((resolve, reject) => {
        getAction('/blaze-sys/k00/k0006/DictManage/query', { table: table, condition: condition, select: select }).then(res => {
          if (res.success) {
            resolve(res.result)
          } else {
            resolve(null)
          }
        })
      })
    },

    /*******************************************
     * 获取用户基本信息
     *
     * 注意调用本方法需要添加 await
     *******************************************/
    $getSysUser(userId) {
      return new Promise((resolve, reject) => {
        if (sessionStorage['SYS_USER_' + userId]) {
          resolve(JSON.parse(sessionStorage['SYS_USER_' + userId]))
        } else {
          this.$query('sys_user', userId).then(res => {
            if (res.length > 0) {
              sessionStorage['SYS_USER_' + userId] = JSON.stringify(res[0])
              resolve(res[0])
            } else {
              resolve(null)
            }
          })
        }
      })
    },

    /*******************************************
     * 获取适用日历规则
     * 只有userId有非空值，则查找该userId所适用的日历规则
     * 只有departId有非空值，则查找该departId所适用的日历规则
     * userId和departId同时有非空值，则无视userId，效果等同于只设置departId
     *
     * 注意调用本方法需要添加 await
     *******************************************/
    $getCalendarRule(userId, departId) {
      if (!userId) userId = ''
      if (!departId) departId = ''

      return new Promise((resolve, reject) => {
        if (sessionStorage['CALENDAR_RULE_' + userId + departId]) {
          resolve(JSON.parse(sessionStorage['CALENDAR_RULE_' + userId + departId]))
        } else {
          getAction('/CalendarRuleManage/getCalendarRule', { userId: userId, departId: departId }).then(res => {
            if (res.success) {
              if (res.result) {
                sessionStorage['CALENDAR_RULE_' + userId + departId] = JSON.stringify(res.result)
                resolve(res.result)
              } else {
                resolve(null)
              }
            }
          })
        }
      })
    },

    /*******************************************
     * 根据日历规则判断对应日期是否为工作日
     * target → YYYY-MM-DD
     *******************************************/
    $isWorkday(target, calendarRule) {
      var calendarFilter = XEUtils.filter(
        calendarRule.tblCalendarRuleDetails,
        item =>
          (item.endDate && item.startDate <= target && target <= item.endDate) ||
          (!item.endDate && item.startDate == target)
      )

      // 是否为工作日(周中 或 节日调班)
      var isWorkday = false

      // 节日调班
      if (calendarFilter && calendarFilter.length > 0) {
        isWorkday = calendarFilter[0].isWorkday
      }
      // 周末
      else if (moment(target).format('d') == '0' || moment(target).format('d') == '6') {
        isWorkday = false
      }
      // 周中
      else {
        isWorkday = true
      }

      return isWorkday
    },

    /*******************************************
     * 获取适用休假规则
     * 只有userId有非空值，则查找该userId所适用的休假规则
     * 只有departId有非空值，则查找该departId所适用的休假规则
     * userId和departId同时有非空值，则无视userId，效果等同于只设置departId
     *
     * 注意调用本方法需要添加 await
     *******************************************/
    $getVacationRule(userId, departId) {
      if (!userId) userId = ''
      if (!departId) departId = ''

      return new Promise((resolve, reject) => {
        if (sessionStorage['VACATION_RULE_' + userId + departId]) {
          resolve(JSON.parse(sessionStorage['VACATION_RULE_' + userId + departId]))
        } else {
          getAction('/VacationRuleManage/getVacationRule', { userId: userId, departId: departId }).then(res => {
            if (res.success) {
              if (res.result) {
                sessionStorage['VACATION_RULE_' + userId + departId] = JSON.stringify(res.result)
                resolve(res.result)
              } else {
                resolve(null)
              }
            }
          })
        }
      })
    },

    /*******************************************
     * 获取适用考勤规则
     * 注意调用本方法需要添加 await
     *******************************************/
    $getAttendanceRule(userId) {
      if (!userId) {
        userId = this.$getLoginUser().id
      }

      return new Promise((resolve, reject) => {
        if (sessionStorage['ATTENDANCE_RULE_' + userId]) {
          resolve(JSON.parse(sessionStorage['ATTENDANCE_RULE_' + userId]))
        } else {
          getAction('/AttendanceRuleManage/getAttendanceRule', { userId: userId }).then(res => {
            if (res.success) {
              if (res.result) {
                sessionStorage['ATTENDANCE_RULE_' + userId] = JSON.stringify(res.result)
                resolve(res.result)
              } else {
                resolve(null)
              }
            }
          })
        }
      })
    },

    /*******************************************
     * 下载模板文件
     *******************************************/
    $downloadTemplate(templateName) {
      if (!templateName) {
        this.$message.warn('请设置模板文件名称')
        return
      }

      postAction('/sys/common/downloadTemplate', { templateName: templateName })
        .then(res => {
          if (res.success) {
            // 处理成功
            downloadFile(res.message)
          }
        })
        .finally(() => {})
    },

    /*******************************************
     * 计算日期之差
     * 比如2个月零13天则返回'2.13'
     *******************************************/
    $monthDayDiff(startDate, endDate) {
      startDate = moment(startDate).format('YYYY-MM-DD')
      endDate = moment(endDate)
        .add(1, 'd')
        .format('YYYY-MM-DD')

      let flag = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2]
      let start = new Date(startDate)
      let end = new Date(endDate)
      let year = end.getFullYear() - start.getFullYear()
      let month = end.getMonth() - start.getMonth()
      let day = end.getDate() - start.getDate()
      if (month < 0) {
        year--
        month = end.getMonth() + (12 - start.getMonth())
      }
      if (day < 0) {
        month--
        let index = flag.findIndex(temp => {
          return temp === start.getMonth() + 1
        })
        let monthLength
        if (index <= 6) {
          monthLength = 31
        } else if (index > 6 && index <= 10) {
          monthLength = 30
        } else {
          monthLength = 28
        }
        day = end.getDate() + (monthLength - start.getDate())
      }
      console.log(`相差${12 * year + month}月${day}天`)
      return 12 * year + month + '.' + day
    },

    /*******************************************
     * 渲染级联选择
     *******************************************/
    $displayRender({ labels, selectedOptions }) {
      if (selectedOptions.length > 1) {
        return (
          <span>
            <span>{selectedOptions[0].label}</span>
            <JSlash></JSlash>
            <span>{selectedOptions[1].label}</span>
          </span>
        )
      } else if (selectedOptions.length > 0) {
        return <span>{selectedOptions[0].label}</span>
      } else {
        return null
      }
    },

    ///*******************************************
    // * 计算文件MD5
    // *******************************************/
    //$computeMD5(file) {
    //  return new Promise(function(resolve, reject) {
    //    let fileReader = new FileReader()
    //    let time = new Date().getTime()
    //    let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
    //    let currentChunk = 0
    //    const chunkSize = 10 * 1024 * 1000
    //    let chunks = Math.ceil(file.size / chunkSize)
    //    let spark = new SparkMD5.ArrayBuffer()
    //    // 由于计算整个文件的Md5太慢，因此采用只计算第1块文件的md5的方式
    //    let chunkNumberMD5 = 1

    //    loadNext()

    //    fileReader.onload = e => {
    //      spark.append(e.target.result)

    //      if (currentChunk < chunkNumberMD5) {
    //        currentChunk++
    //        loadNext()
    //      } else {
    //        let md5 = spark.end()
    //        resolve(md5)
    //      }
    //    }

    //    fileReader.onerror = function() {
    //      resolve('-1')
    //    }

    //    function loadNext() {
    //      let start = currentChunk * chunkSize
    //      let end = start + chunkSize >= file.size ? file.size : start + chunkSize

    //      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    //    }
    //  })
    //}
  }
}

